<template>
    <div>
        <!-- add new keyword section -->
        <v-layout row>
            <v-flex md4 sm6 class="pr-3">
                <h3 class="subheading font-weight-regular">Keyword<span class="necessary-text--color"> - Necessary</span></h3>
                <p class="keyword-add-input--color caption create-keyword--height">The main keyword of phrase for which
                    your project will collect data.</p>
<!--                    <span class="keyword-add-input&#45;&#45;color caption">Not case sensitive</span>-->
                    <!--
                        @blur="$v.necessaryKeyword.$touch()"
                     -->
                <v-text-field
                        :disabled="authenticatedUser.is_user"
                        :error-messages="necessaryKeywordError"
                        @keyup.enter="addKeyword"
                        autofocus
                        background-color="#e2e2e2"
                        class="custom-box"
                        height="46"
                        hint="Not Case Sensitive"
                        outline
                        ref="necessaryInput"
                        required
                        single-line
                        v-model="$v.necessaryKeyword.$model"
                />
            </v-flex>
            <v-flex md4 sm6 class="px-3">
                <h3 class="subheading font-weight-regular">Required keywords<span class="keyword-add-input--color"> - Option</span></h3>
                <p class="keyword-add-input--color caption create-keyword--height">Additional keywords - <span
                        class="monitor-title--color caption">Each of which must appear</span> in order for the
                    mention to be collected</p>
                   <!--                    <span class="keyword-add-input&#45;&#45;color caption">seperate keywords with a comma</span>-->
                   <!-- disabled -->
                   <v-text-field
                           disabled
                           height="41"
                           outline
                           single-line
                           background-color="#e2e2e2"
                           class="custom-box mt-3"
                           v-model="requiredKeyword"
                   />
            </v-flex>
            <v-flex md4 sm12 class="pl-3">
                <h3 class="subheading font-weight-regular">Exclusive keywords<span class="keyword-add-input--color"> - Option</span></h3>
                <p class="keyword-add-input--color caption create-keyword--height">Addtional keywords - <span
                        class="monitor-title--color caption">None of which can appear</span> if the mention is to be
                    collected.</p>
                <span></span>
                <!--                    <span class="keyword-add-input&#45;&#45;color caption">seperate keywords with a comma</span>-->
                <!-- disabled -->
                <v-text-field
                        disabled
                        height="41"
                        outline
                        single-line
                        background-color="#e2e2e2"
                        class="custom-box"
                        v-model="exclusiveKeyword"

                />
            </v-flex>
        </v-layout>
        <v-layout row justify-end>
            <v-flex text-xs-right xs4>
                <v-btn
                        depressed
                        @click="addKeyword"
                        color="bindezcolor"
                        :dark="!authenticatedUser.is_user"
                        :disabled="authenticatedUser.is_user"
                >
                    <v-icon>add</v-icon>
                    <span class="text-capitalize font-weight-regular" style="font-size: 14px;">Add next keyword</span>
                </v-btn>
            </v-flex>
        </v-layout>
        <!--end add new keyword section -->
        <hr style="margin: 10px 0; border:0; border-top:1px solid #bababa;">
        <!-- overall keywords section -->
        <h3 class="subheading font-weight-regular mb-3">Overall Keywords</h3>
        <v-layout wrap row mb-3 class="scroll-y" style="height:188px;">
            <v-flex class="mx-2" md12 sm12 xs12 style="border:1px solid #AFBAC8">
                <v-chip
                        :disabled="authenticatedUser.is_user"
                        color="bindezcolor"
                        text-color="#fff"
                        v-model="keyword.chip"
                        close
                        label
                        v-for="keyword in monitorKeywords"
                        :key="keyword.name"
                        @input="deleteKeyword(keyword)"
                >
                    {{keyword.name | formatKeyword}}
                </v-chip>
            </v-flex>
        </v-layout>
        <!-- end overall keywords section -->
        <div class="text-xs-right">
            <v-btn
                    :loading="processing"
                    :disabled="keywordSectionInvalid"
                    depressed
                    color="bindezcolor"
                    :dark="!keywordSectionInvalid"
                    @click="monitorAction"
            >
                <span class="text-capitalize font-weight-regular" style="font-size: 14px;">{{ create ? 'Next' : 'Update Monitor'}}</span>
            </v-btn>
        </div>
        <v-snackbar
            v-model="existingKeyword"
            :top="true"
            :timeout="2500"
            color="#eb2929"
        >
            Keyword already existed!
        </v-snackbar>
    </div>
</template>

<script>
    import {notAllowSpecialCharacter, includeSpecialCharacter} from "@/validators";
    import {required} from 'vuelidate/lib/validators'
	import {mapMutations, mapState} from 'vuex'
    import authCurrentUser from "../../mixins/authCurrentUser";

	export default {
		name: "KeywordsSection",
		props: ['create','processing'],
        mixins: [authCurrentUser],

		data() {
			return {
				necessaryKeyword: "",
                requiredKeyword:"",
                exclusiveKeyword:"",
                existingKeyword: false
			}
		},
		validations: {
			necessaryKeyword: {
				required,
                nonSpecialCharacter:notAllowSpecialCharacter,
                withSpecialCharacter:includeSpecialCharacter,
			}
		},

		computed: {
			...mapState('monitors', [
				'keywords',
				'keywordSectionInvalid',
                'monitorType'
			]),

			...mapState([
				'monitor'
			]),

			necessaryKeywordError() {
				const errors = [];
				if (!this.$v.necessaryKeyword.$dirty) return errors;
				if (!this.$v.necessaryKeyword.nonSpecialCharacter && this.$v.necessaryKeyword.required) errors.push("Only # and _ are allowed.");
				if (!this.$v.necessaryKeyword.withSpecialCharacter && this.$v.necessaryKeyword.required) errors.push("# and _ are allowed with other characters.");
				if (!this.$v.necessaryKeyword.required && this.monitorType === 'keyword') errors.push("Necessary Keyword is required");
				return errors
			},

            monitorKeywords:{
				get(){
					return this.keywords.map(keyword => ({
						name: keyword,
						chip: true
					}))
                },
                set(keywords){
					this.setMonitorKeywords(keywords);
                }
            }
		},

		methods: {
			...mapMutations('monitors', [
				'setKeywordSectionValidation',
				'setMonitorKeywords'
			]),

			addKeyword() {
				this.$v.$touch();
				if (!this.$v.necessaryKeyword.$invalid) {
					let keywords = this.monitorKeywords.map(k => k.name);
					let keyword = [];
					if(this.requiredKeyword){
						let requireKeywords  = this.requiredKeyword.includes(",") ? this.requiredKeyword.split(",").map(keyword => `+${keyword}`) : `+${this.requiredKeyword}`;
						keyword = typeof requireKeywords === Array ? requireKeywords : [...keyword, requireKeywords];
					}
					if(this.exclusiveKeyword){
						let exclusiveKeywords = this.exclusiveKeyword.includes(",") ? this.exclusiveKeyword.split(",").map(keyword => `-${keyword}`) : `-${this.exclusiveKeyword}`;
						keyword = typeof exclusiveKeywords === Array ? exclusiveKeywords : [...keyword, exclusiveKeywords];
					}
                    keyword = [this.necessaryKeyword, ...keyword].flat().join("|");
					if (keywords.includes(keyword)) {
						this.existingKeyword = true;
						return
					}
					keywords.push(keyword);
					this.monitorKeywords = keywords;
					this.$ua.trackEvent("Monitor", "click", `${this.authenticatedUser.email || 'User'} add new keyword to monitor(${ this.monitor ? this.monitor.monitor_uuid : ''}`);
					this.necessaryKeyword = "";
					this.requiredKeyword = "";
					this.exclusiveKeyword = "";
					this.$refs.necessaryInput.focus();
				}
			},

			deleteKeyword(keyword) {
				this.$ua.trackEvent("Monitor", "click", `${this.authenticatedUser.email || 'User'} remove keyword from monitor(${ this.monitor ? this.monitor.monitor_uuid : ''}`);
				let keywords = this.monitorKeywords.map(k => k.name);
				keywords.splice(keywords.indexOf(keyword.name), 1);
				this.monitorKeywords = keywords;
			},

			monitorAction() {
				//this.keywords.length > 0 || this.monitorType === 'page'
				if (this.keywords.length > 0) {
					if (this.create) {
						this.$emit('next')
					} else {
						this.$emit('next', 'update')
					}
				}
			},
		},

        watch:{
			keywords(keywords){
				// if(this.monitorType === 'page'){
				// 	this.setKeywordSectionValidation(false);
                // }else{
				// 	keywords.length > 0 ? this.setKeywordSectionValidation(false) : this.setKeywordSectionValidation(true);
				// }
				keywords.length > 0 ? this.setKeywordSectionValidation(false) : this.setKeywordSectionValidation(true);
			},

            // monitorType(type){
			// 	let validate = type === 'page' || (type === 'keyword' && this.keywords.length > 0); // if keyword type have zero or more keyword second validation should pass
			// 	this.setKeywordSectionValidation(!validate);
            // }
        },

		created() {
			if(!this.keywords.length > 0){
				this.setKeywordSectionValidation(true);
			}
		}
	}
</script>

<style scoped>
    .necessary-text--color {
        color: #EB2929;
    }

    .create-keyword--height {
        min-height: 36px;
    }

    .keyword-box--wrapper{
        height: 100px;
        margin-top: 10px;
    }
</style>
